import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface ConfirmParams {
  type: 'neutral' | 'strong';
  title: string;
  description: string;
}

@Component({
  selector: 'cc-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})

export class ConfirmComponent implements OnInit {
  public neutral: boolean;
  public strong: boolean;
  public title: string;
  public description: string;

  constructor(public dialogRef: MatDialogRef<ConfirmComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ConfirmParams
  ) {}

  ngOnInit() {}

  close() {
    this.dialogRef.close();
  }
}
